import { render } from "./BaseInfo.vue?vue&type=template&id=abe9b1a8&scoped=true"
import script from "./BaseInfo.vue?vue&type=script&lang=js"
export * from "./BaseInfo.vue?vue&type=script&lang=js"

import "./BaseInfo.vue?vue&type=style&index=0&id=abe9b1a8&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe9b1a8"]])

export default __exports__